export default __webpack_public_path__ + "static/media/hht1_ep03_timeline_q02_a.c4a24b83.png";